<template>
  <div class="page-head">
    <div class="page-head__main">
      <div v-if="crumbs && crumbs.length" class="page-head__crumbs">
        <template v-for="(c, i) in crumbs" :key="i">
          <span v-if="i > 0" class="page-head__sep">/</span>
          <span :class="i === crumbs.length - 1 ? 'is-current' : ''">{{ c }}</span>
        </template>
      </div>
      <h2 class="page-head__title">{{ title }}</h2>
      <p v-if="subtitle" class="page-head__subtitle">{{ subtitle }}</p>
      <slot />
    </div>
    <div v-if="$slots.actions" class="page-head__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    crumbs: { type: Array, default: () => [] }
  }
})
</script>

<style scoped>
.page-head {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}

.page-head__main {
  min-width: 0;
}

.page-head__crumbs {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--text-tertiary);
  margin-bottom: 4px;
}

.page-head__crumbs .is-current {
  color: var(--text-secondary);
}

.page-head__sep {
  color: var(--text-disabled);
}

.page-head__title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.3;
  color: var(--text-primary);
}

.page-head__subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--text-tertiary);
}

.page-head__actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
</style>
